import * as React from 'react'
import styled, { css } from 'styled-components'
import { theme } from 'global'
import { Slider, Box } from 'components'

interface IQuestionSliderProps {
  onChange: (result: number) => void
  onClick: (index: number) => void
  vertical: boolean
  sliderLabels: string[]
  selectedIndex: number
  sliderPercentage: number
}

interface VerticalProp {
  vertical: boolean
}

const QuestionSliderWrapper = styled(Box)<VerticalProp>`
  width: 100%;
  ${props => css`
    ${props.vertical &&
      css`
        display: flex;
        justify-content: center;
      `}
  `}
`

const LabelsWrapper = styled.div<VerticalProp>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${props => css`
    ${props.vertical &&
      css`
        width: auto;
        flex-direction: column-reverse;
        padding: 10px 43px 10px 0;
        text-align: right;
      `}
    ${!props.vertical &&
      css`
        margin-bottom: 40px;
      `}
  `}
`

interface LabelProps {
  bold?: boolean
  vertical: boolean
  first: boolean
  last: boolean
}

const Label = styled.a<LabelProps>`
  color: ${theme.colors.white};
  font-size: 16px;
  font-weight: bold;
  opacity: 0.6;
  letter-spacing: -0.4px;
  line-height: 19px;
  @media (hover: none) {
    &:hover {
      opacity: 1;
    }
  }
  ${({ bold, vertical, first, last }) => css`
    ${bold &&
      css`
        opacity: 1;
      `}
    ${!vertical &&
      css`
        max-width: 100px;
        text-align: center;
      `}
    /* Better aligns the labels with the slider positions */
    ${!vertical &&
      first &&
      css`
        margin-left: -30px;
      `}
    ${!vertical &&
      last &&
      css`
        margin-right: -30px;
      `}
  `}
`

export const QuestionSlider = ({
  onChange,
  onClick,
  vertical,
  sliderLabels,
  selectedIndex = 0,
  sliderPercentage,
}: IQuestionSliderProps) => {
  return (
    <QuestionSliderWrapper vertical={vertical} mb={[0, 0, 5, 5]}>
      <LabelsWrapper vertical={vertical}>
        {sliderLabels.map((text: string, i: number) => (
          <Label
            key={text}
            bold={selectedIndex === i}
            title={text}
            vertical={vertical}
            first={i === 0}
            last={i === sliderLabels.length - 1}
            onClick={() => onClick(i)}
          >
            {text}
          </Label>
        ))}
      </LabelsWrapper>
      <Slider
        startOffset={vertical ? 14 : 16}
        endOffset={vertical ? -20 : -23}
        railOffset={-20}
        onChange={onChange}
        vertical={vertical}
        percentage={sliderPercentage}
      />
    </QuestionSliderWrapper>
  )
}
